module.exports = __webpack_public_path__ + "assets/img/12@3x.40e831ca.png";